export default __webpack_public_path__ + "static/media/LargeMeditationIllustration.f60867b5.svg";